import React from "react";
import { UserPlus, Bell, Sun, GraduationCap, Sparkles, CalendarClock, Trophy, MessagesSquare, ClipboardList, Wallet, ClipboardCheck, BookOpen } from "lucide-react";

export const CAP_ICONS = { UserPlus, Bell, Sun, GraduationCap, Sparkles, CalendarClock, Trophy, MessagesSquare, ClipboardList, Wallet, ClipboardCheck, BookOpen };

export const CapIcon = ({ name, className }) => {
  const Icon = CAP_ICONS[name] || BookOpen;
  return <Icon className={className} />;
};
